import { applyTheme } from "@cloudscape-design/components/theming"

/**
 * Applies global theme overrides.
 */
export function applyGlobalTheme() {
  applyTheme({
    theme: {
      tokens: {
        colorBackgroundLayoutMain: {
          light: "#f5f5f5",
        },
      },
    },
  })
}
